export default __webpack_public_path__ + "static/media/png.eed7586c.svg";